import { AnalyticsEvent } from '../models';

export class LandingPageLoadEvent implements AnalyticsEvent {
  name = 'LandingPageLoadEvent';
  constructor(public readonly pageDetails?: any) {}

}
